import { render } from "./ApiTokenManager.vue?vue&type=template&id=46d3052f"
import script from "./ApiTokenManager.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiTokenManager.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/API/Partials/ApiTokenManager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46d3052f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46d3052f', __exports__)) {
    api.reload('46d3052f', __exports__)
  }
  
  module.hot.accept("./ApiTokenManager.vue?vue&type=template&id=46d3052f", () => {
    api.rerender('46d3052f', render)
  })

}


export default __exports__